// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep.fa-pencil-square-o {
  cursor: pointer;
  font-size: 18px;
}

.page-heading__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -10px;
}
.page-heading__inner a {
  font-family: "Open Sans", sans-serif;
}
.page-heading__inner .page-heading__col {
  padding: 0 10px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col--left {
    width: 100%;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right {
  margin-left: auto;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right {
    width: 100%;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li {
  list-style: none;
  position: relative;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li {
    margin-top: 0;
    margin-bottom: 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li:not(:last-child) {
  margin-right: 15px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li:not(:last-child) {
    margin-right: 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
  font-size: 16px;
  color: #676a6a;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
    font-size: 13px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
  padding: 11px 14px;
  border-right: 1px solid #ededed;
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
    padding: 10px 12px;
  }
}
@media only screen and (max-width: 991px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
    padding: 9px 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
  padding: 11px 14px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
    padding: 10px 12px;
  }
}
@media only screen and (max-width: 991px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
    padding: 9px 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a:hover {
  border: 1px solid #CFDBE2;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li:hover > ul {
  display: block;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul {
  margin: 0;
  padding: 0;
  display: none;
  position: absolute;
  top: calc(100% - 1px);
  right: 0;
  width: 144px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  background-color: #fff;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li {
  list-style: none;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li + li {
  border-top: 1px solid #dcdcdc;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li a {
  color: #696969;
  text-align: center;
  padding: 8px 20px;
  font-size: 13px;
  display: block;
  transition: all ease 0.3s;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li a:hover {
  background-color: #f9f9f9;
}

::ng-deep.cancelTool.tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
  margin-left: 15px;
  cursor: pointer;
}
::ng-deep.cancelTool.tooltipicon .tooltiptext {
  visibility: hidden;
  width: 150px;
  color: #676a6c;
  background-color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: -25px;
  left: 10px;
  z-index: 1;
}
::ng-deep.cancelTool.tooltipicon:hover .tooltiptext {
  visibility: visible;
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #28a745 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled.wbg {
  background-color: #fff !important;
  color: #676A6C;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #dc3545;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);
}
::ng-deep .swal2-show .swal2-confirm.swal2-styled.gbg {
  background-color: #28a745 !important;
}
::ng-deep .swal2-show .swal2-confirm.swal2-styled.gbg:focus {
  box-shadow: none;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
  box-shadow: 0 0 0 3px #F8BB86;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
  box-shadow: 0 0 0 3px #575757;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
  box-shadow: 0 0 0 3px #797979;
}

.swal2-show button.swal2-cancel.swal2-styled:focus {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(208, 208, 208, 0.5);
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999999999999;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: 390px;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.btn-primary {
  margin-right: 10px;
}

::ng-deep.download__pdf .btn {
  margin: 0 0 10px 0;
}

::ng-deep span.swal2-icon-text.question {
  border: 2.5px solid #F8BB86;
  width: 100px;
  border-radius: 50%;
}

.loader-container {
  display: none;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.close-modal form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}

::ng-deep .reset-modal {
  display: none;
}

::ng-deep .mainnav--left {
  justify-content: flex-start !important;
  margin-top: 10px !important;
  margin-bottom: 20px !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul {
  border: none !important;
  border-radius: 0 !important;
  overflow: visible !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  gap: 0 !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  background: none !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  margin: 0 !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li:not(:last-child)::after {
  content: "" !important;
  display: inline-block !important;
  width: 6px !important;
  height: 6px !important;
  border-top: 1.5px solid #aaa !important;
  border-right: 1.5px solid #aaa !important;
  transform: rotate(45deg) !important;
  margin: 0 6px !important;
  flex-shrink: 0 !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active a, ::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--cl a, ::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--id a, ::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--dev a, ::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--imple a {
  font-weight: 700 !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--cl a {
  color: rgb(0, 173, 208) !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--id a {
  color: rgb(255, 121, 0) !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--dev a {
  color: rgb(105, 190, 40) !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li.active--imple a {
  color: rgb(245, 67, 89) !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li > a {
  padding: 4px 4px !important;
  font-size: 13px !important;
  display: inline-block !important;
  width: auto !important;
  position: static !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li > a::after {
  content: none !important;
  display: none !important;
}
::ng-deep .mainnav--left nav.cn-print-nav.cn-online ul > li > a span {
  transform: none !important;
  position: static !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul {
  --bdr-clr: #cfdbe2;
  border: 1px solid var(--bdr-clr) !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li a::after {
  background-color: #efeaec !important;
  border-top: 1px solid var(--bdr-clr) !important;
  border-right: 1px solid var(--bdr-clr) !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li.active a::after {
  background-color: #f1f1f2 !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li.active--cl a::after {
  background-color: rgb(0, 173, 208) !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li.active--id a::after {
  background-color: rgb(255, 121, 0) !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li.active--dev a::after {
  background-color: rgb(105, 190, 40) !important;
}
::ng-deep .mainnav--editmode .cn-print-nav ul li.active--imple a::after {
  background-color: rgb(245, 67, 89) !important;
}
::ng-deep .mainnav__editmodeicon {
  display: flex;
  align-items: center;
  margin-left: auto !important;
}
::ng-deep .mainnav__editmodeicon ul {
  height: auto !important;
}
::ng-deep .mainnav__list {
  margin: 0;
  padding: 0;
  display: flex;
  overflow: hidden;
}
::ng-deep .mainnav__list li {
  list-style: none;
  padding: 0;
}
::ng-deep .mainnav__list li + li {
  border-left: 1px solid #cfdbe2;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .mainnav__list li {
    flex: 1;
  }
}
::ng-deep .mainnav__list li.active a {
  color: #fff;
}
::ng-deep .mainnav__list li.clarify a {
  border-radius: 6px 0 0 6px;
  border-left: 1px solid #cfdbe2;
}
::ng-deep .mainnav__list li.clarify a:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep .mainnav__list li.ideate a:hover {
  background-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep .mainnav__list li.develop a:hover {
  background-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep .mainnav__list li.implement a {
  border-radius: 0 6px 6px 0;
  border-right: 1px solid #cfdbe2;
}
::ng-deep .mainnav__list li.implement a:hover {
  background-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep .mainnav__list li a {
  border-top: 1px solid #CFDBE2;
  border-bottom: 1px solid #CFDBE2;
  transition: 0.3s;
  display: inline-block;
  color: #b9b9ba;
  width: 100%;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .mainnav__list li a {
    padding: 11px 5px !important;
    font-size: 11px !important;
  }
}

.pdf-modal {
  display: none;
}

::ng-deep .card__bwnh3ai {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 6px 8px;
  cursor: pointer;
  color: #6d6e71;
  font-size: 14px;
  border-radius: 4px;
  transition: color 0.3s ease, background-color 0.3s ease;
}
::ng-deep .card__bwnh3ai:hover {
  color: rgb(105, 190, 40);
  background-color: rgba(0, 0, 0, 0.05);
}
::ng-deep .card__bwnh3ai i {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/challenges.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AAjZA;EACE,eAAA;EACA,eAAA;AAoZF;;AAjZA;EAGE,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,eAAA;AAoZF;AAlZE;EACE,oCAAA;AAoZJ;AAjZE;EACE,eAAA;AAmZJ;AA/YM;EAFF;IAGI,WAAA;EAkZN;AACF;AA/YI;EACE,iBAAA;AAiZN;AA/YM;EAHF;IAII,WAAA;EAkZN;AACF;AAhZM;EACE,UAAA;EACA,SAAA;EAGA,aAAA;EAEA,eAAA;AAkZR;AAhZQ;EACE,gBAAA;EACA,kBAAA;AAkZV;AAhZU;EAJF;IAKI,aAAA;IACA,mBAAA;EAmZV;AACF;AAjZU;EACE,kBAAA;AAmZZ;AAjZY;EAHF;IAII,kBAAA;EAoZZ;AACF;AAjZU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,eAAA;EAGA,yBAAA;AAmZZ;AAjZY;EAjBF;IAkBI,eAAA;EAoZZ;AACF;AAlZY;EArBF;IAsBI,eAAA;EAqZZ;AACF;AAnZY;EACE,kBAAA;EACA,+BAAA;EAGA,aAAA;EAGA,mBAAA;AAqZd;AAnZc;EAVF;IAWI,kBAAA;EAsZd;AACF;AApZc;EAdF;IAeI,iBAAA;EAuZd;AACF;AApZY;EACE,kBAAA;AAsZd;AApZc;EAHF;IAII,kBAAA;EAuZd;AACF;AArZc;EAPF;IAQI,iBAAA;EAwZd;AACF;AArZY;EACE,yBAAA;AAuZd;AAnZU;EACE,cAAA;AAqZZ;AAlZU;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAoZZ;AAlZY;EACE,gBAAA;AAoZd;AAlZc;EACE,6BAAA;AAoZhB;AAjZc;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EAGA,yBAAA;AAmZhB;AAjZgB;EACE,yBAAA;AAmZlB;;AAxYA;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AA2YF;AAzYE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;AA2YJ;AAvYI;EACE,mBAAA;AAyYN;;AApYA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAuYF;;AApYA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAuYF;AArYE;EACE,aAAA;AAuYJ;AApYE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAsYJ;AApYI;EACE,aAAA;EACA,4CAAA;AAsYN;AAnYI;EACE,iCAAA;EACA,cAAA;AAqYN;AAjYE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAmYJ;AAjYI;EACE,aAAA;EACA,4CAAA;AAmYN;AA/XE;EACE,oCAAA;AAiYJ;AA/XI;EACE,gBAAA;AAiYN;AA7XE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AA+XJ;AA7XI;EACE,aAAA;EACA,6BAAA;AA+XN;AA3XE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AA6XJ;AA3XI;EACE,aAAA;EACA,6BAAA;AA6XN;AAzXE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AA2XJ;AAzXI;EACE,aAAA;EACA,6BAAA;AA2XN;;AAtXA;EACE,UAAA;EACA,8CAAA;AAyXF;;AAtXA;EACE,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,qBAAA;AAyXF;;AAtXA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AAyXF;;AAtXA;EACE,oCAAA;AAyXF;;AAtXA;EACE,kBAAA;AAyXF;;AAlXE;EACE,kBAAA;AAqXJ;;AAhXA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;AAmXF;;AAhXA;EACE,aAAA;AAmXF;;AAhXA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAmXF;;AAhXA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAmXF;;AA/WA;EACE,mCAAA;EACA,UAAA;AAkXF;;AA/WA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAkXF;;AA/WA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAkXF;;AA/WA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAkXF;;AA/WA;EACE;IACE,UAAA;EAkXF;EA/WA;IACE,UAAA;EAiXF;EA9WA;IACE,UAAA;EAgXF;AACF;AAvWI;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAyWN;;AApWA;EAEE,aAAA;AAsWF;;AAhWM;EACI,sCAAA;EACA,2BAAA;EACA,8BAAA;AAmWV;AA/Vc;EACI,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,8BAAA;EACA,iBAAA;AAiWlB;AA9Vc;EACI,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,oBAAA;AAgWlB;AA9VkB;EACI,sBAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;EACA,uCAAA;EACA,yCAAA;EACA,mCAAA;EACA,wBAAA;EACA,yBAAA;AAgWtB;AA7VkB;EAKI,2BAAA;AA2VtB;AAxVkB;EAAiB,kCAAA;AA2VnC;AA1VkB;EAAiB,kCAAA;AA6VnC;AA5VkB;EAAkB,mCAAA;AA+VpC;AA9VkB;EAAoB,kCAAA;AAiWtC;AA9Vc;EACI,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,sBAAA;EACA,2BAAA;AAgWlB;AA9VkB;EACI,wBAAA;EACA,wBAAA;AAgWtB;AA7VkB;EACI,0BAAA;EACA,2BAAA;AA+VtB;AAnVkB;EACI,kBAAA;EACA,2CAAA;AAqVtB;AAjV8B;EACI,oCAAA;EACA,+CAAA;EACA,iDAAA;AAmVlC;AA7UkC;EACI,oCAAA;AA+UtC;AAxUkC;EACI,6CAAA;AA0UtC;AApUkC;EACI,6CAAA;AAsUtC;AAhUkC;EACI,8CAAA;AAkUtC;AA5TkC;EACI,6CAAA;AA8TtC;AApTM;EACI,aAAA;EACA,mBAAA;EACA,4BAAA;AAsTV;AApTU;EACI,uBAAA;AAsTd;AAlTM;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;AAoTV;AAlTU;EACI,gBAAA;EACA,UAAA;AAoTd;AAlTc;EACI,8BAAA;AAoTlB;AAjTc;EARJ;IASQ,OAAA;EAoThB;AACF;AAhTkB;EACI,WAAA;AAkTtB;AA5SkB;EACI,0BAAA;EACA,8BAAA;AA8StB;AA5SsB;EACI,kCD7nBV;EC8nBU,WAAA;AA8S1B;AArSsB;EACI,kCDvoBX;ECwoBW,WAAA;AAuS1B;AA9RsB;EACI,kCDlpBX;ECmpBW,WAAA;AAgS1B;AAzRkB;EACI,0BAAA;EACA,+BAAA;AA2RtB;AAzRsB;EACI,kCD7pBR;EC8pBQ,WAAA;AA2R1B;AAtRc;EACI,6BAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAwRlB;AAtRkB;EATJ;IAUQ,4BAAA;IACA,0BAAA;EAyRpB;AACF;;AAlRA;EACE,aAAA;AAqRF;;AAjRA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cDlrBmB;ECmrBnB,eAAA;EACA,kBAAA;EACA,uDAAA;AAoRF;AAlRE;EACE,wBDzsBY;EC0sBZ,qCAAA;AAoRJ;AAjRE;EACE,eAAA;AAmRJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './_cn-shared';\n\n::ng-deep.fa-pencil-square-o {\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.page-heading__inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin: 0 -10px;\n\n  a {\n    font-family: 'Open Sans', sans-serif;\n  }\n\n  .page-heading__col {\n    padding: 0 10px;\n\n    &--left {\n\n      @media #{$mq-pc} {\n        width: 100%;\n      }\n    }\n\n    &.page-heading__col--right {\n      margin-left: auto;\n\n      @media #{$mq-pc} {\n        width: 100%;\n      }\n\n      &>ul {\n        padding: 0;\n        margin: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        &>li {\n          list-style: none;\n          position: relative;\n\n          @media #{$mq-pc} {\n            margin-top: 0;\n            margin-bottom: 10px;\n          }\n\n          &:not(:last-child) {\n            margin-right: 15px;\n\n            @media #{$mq-pc} {\n              margin-right: 10px;\n            }\n          }\n\n          &>a {\n            font-size: 16px;\n            color: #676a6a;\n            font-weight: 700;\n            background-color: #fff;\n            border: 1px solid #ededed;\n            border-radius: 6px;\n            overflow: hidden;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            @media #{$mq-pc} {\n              font-size: 14px;\n            }\n\n            @media #{$mq-sm} {\n              font-size: 13px;\n            }\n\n            .page-heading__icon {\n              padding: 11px 14px;\n              border-right: 1px solid #ededed;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n              -ms-flex-align: center;\n              align-items: center;\n\n              @media #{$mq-pc} {\n                padding: 10px 12px;\n              }\n\n              @media #{$mq-md} {\n                padding: 9px 10px;\n              }\n            }\n\n            .page-heading__text {\n              padding: 11px 14px;\n\n              @media #{$mq-pc} {\n                padding: 10px 12px;\n              }\n\n              @media #{$mq-md} {\n                padding: 9px 10px;\n              }\n            }\n\n            &:hover {\n              border: 1px solid $cn-border-color;\n            }\n          }\n\n          &:hover>ul {\n            display: block;\n          }\n\n          ul {\n            margin: 0;\n            padding: 0;\n            display: none;\n            position: absolute;\n            top: calc(100% - 1px);\n            right: 0;\n            width: 144px;\n            border: 1px solid #dcdcdc;\n            border-radius: 3px;\n            background-color: #fff;\n\n            li {\n              list-style: none;\n\n              &+li {\n                border-top: 1px solid #dcdcdc;\n              }\n\n              a {\n                color: #696969;\n                text-align: center;\n                padding: 8px 20px;\n                font-size: 13px;\n                display: block;\n                -webkit-transition: all ease 0.3s;\n                -o-transition: all ease 0.3s;\n                transition: all ease 0.3s;\n\n                &:hover {\n                  background-color: #f9f9f9;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep.cancelTool.tooltipicon {\n  position: relative;\n  font-size: 18px;\n  display: inline-block;\n  margin-left: 15px;\n  cursor: pointer;\n\n  .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    color: #676a6c;\n    background-color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 6px;\n    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n    font-size: 13px;\n    font-family: 'Open Sans', sans-serif;\n    line-height: 1.5;\n    position: absolute;\n    top: -25px;\n    left: 10px;\n    z-index: 1;\n  }\n\n  &:hover {\n    .tooltiptext {\n      visibility: visible;\n    }\n  }\n}\n\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus {\n    outline: none;\n  }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #28a745 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);\n    }\n\n    &.wbg {\n      background-color: #fff !important;\n      color: #676A6C;\n    }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);\n    }\n  }\n\n  .swal2-confirm.swal2-styled.gbg {\n    background-color: #28a745 !important;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid gray;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    border-color: #F8BB86;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #F8BB86;\n    }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #575757;\n    }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #797979;\n    }\n  }\n}\n\n.swal2-show button.swal2-cancel.swal2-styled:focus {\n  opacity: 1;\n  box-shadow: 0 0 0 3px rgba(208, 208, 208, .5);\n}\n\n::ng-deep .swal2-shown {\n  background-color: black;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 999999999999;\n}\n\n::ng-deep.swal2-modal {\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n  margin: auto !important;\n  height: 390px;\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.btn-primary {\n  margin-right: 10px;\n}\n\n::ng-deep.download__pdf {\n  // display: flex;\n  // flex-wrap: wrap;\n\n  .btn {\n    margin: 0 0 10px 0;\n  }\n}\n\n// clarify challenge question\n::ng-deep span.swal2-icon-text.question {\n  border: 2.5px solid #F8BB86;\n  width: 100px;\n  border-radius: 50%;\n}\n\n.loader-container {\n  display: none;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n// 12-12 Close Modal\n\n.close-modal {\n\n  form {\n\n    label {\n      display: inline-block;\n      max-width: 100%;\n      margin-bottom: 5px;\n      font-weight: 700;\n    }\n  }\n}\n\n::ng-deep\n.reset-modal {\n  display: none;;\n}\n\n::ng-deep {\n  .mainnav {\n\n      &--left {\n          justify-content: flex-start !important;\n          margin-top: 10px !important;\n          margin-bottom: 20px !important;\n\n          nav.cn-print-nav.cn-online {\n\n              ul {\n                  border: none !important;\n                  border-radius: 0 !important;\n                  overflow: visible !important;\n                  flex-wrap: nowrap !important;\n                  align-items: center !important;\n                  gap: 0 !important;\n              }\n\n              ul > li {\n                  flex-grow: 0 !important;\n                  flex-shrink: 0 !important;\n                  background: none !important;\n                  display: flex !important;\n                  flex-direction: row !important;\n                  align-items: center !important;\n                  margin: 0 !important;\n\n                  &:not(:last-child)::after {\n                      content: \"\" !important;\n                      display: inline-block !important;\n                      width: 6px !important;\n                      height: 6px !important;\n                      border-top: 1.5px solid #aaa !important;\n                      border-right: 1.5px solid #aaa !important;\n                      transform: rotate(45deg) !important;\n                      margin: 0 6px !important;\n                      flex-shrink: 0 !important;\n                  }\n\n                  &.active a,\n                  &.active--cl a,\n                  &.active--id a,\n                  &.active--dev a,\n                  &.active--imple a {\n                      font-weight: 700 !important;\n                  }\n\n                  &.active--cl a { color: $clarify-color !important; }\n                  &.active--id a { color: $ideate-color !important; }\n                  &.active--dev a { color: $develop-color !important; }\n                  &.active--imple a { color: $implement-color !important; }\n              }\n\n              ul > li > a {\n                  padding: 4px 4px !important;\n                  font-size: 13px !important;\n                  display: inline-block !important;\n                  width: auto !important;\n                  position: static !important;\n\n                  &::after {\n                      content: none !important;\n                      display: none !important;\n                  }\n\n                  span {\n                      transform: none !important;\n                      position: static !important;\n                  }\n              }\n          }\n      }\n\n      &--editmode {\n  \n          .cn-print {\n              \n              &-nav {\n                  \n                  ul {\n                      --bdr-clr: #cfdbe2;\n                      border: 1px solid var(--bdr-clr) !important;\n\n                      li {\n                          a {\n                              &::after {\n                                  background-color: #efeaec !important;\n                                  border-top: 1px solid var(--bdr-clr) !important;\n                                  border-right: 1px solid var(--bdr-clr) !important;\n                              }\n                          }\n\n                          &.active {\n                              a {\n                                  &::after {\n                                      background-color: #f1f1f2 !important;\n                                  }\n                              }\n                          }\n\n                          &.active--cl {\n                              a {\n                                  &::after {\n                                      background-color: $clarify-color !important;\n                                  }\n                              }\n                          }\n                          &.active--id {\n                              a {\n                                  &::after {\n                                      background-color: $ideate-color !important;\n                                  }\n                              }\n                          }\n                          &.active--dev {\n                              a {\n                                  &::after {\n                                      background-color: $develop-color !important;\n                                  }\n                              }\n                          }\n                          &.active--imple {\n                              a {\n                                  &::after {\n                                      background-color: $implement-color !important;\n                                  }\n                              }\n                          }\n                      }\n                  }\n              }\n          }\n      }\n\n      &__editmodeicon {\n          display: flex;\n          align-items: center;\n          margin-left: auto !important;\n\n          ul {\n              height: auto !important;\n          }\n      }\n\n      &__list {\n          margin: 0;\n          padding: 0;\n          display: flex;\n          overflow: hidden;\n\n          li {\n              list-style: none;\n              padding: 0;\n\n              & + li {\n                  border-left: 1px solid #cfdbe2;\n              }\n\n              @media #{$mobile} {\n                  flex: 1;\n              }\n\n              &.active {\n                  \n                  a {\n                      color: #fff;\n                  }\n              }\n\n              &.clarify {\n                  \n                  a {\n                      border-radius: 6px 0 0 6px;\n                      border-left: 1px solid #cfdbe2;\n\n                      &:hover {\n                          background-color: $clarify-color;\n                          color: #fff;\n                      }\n                  }\n              }\n\n              &.ideate {\n                  \n                  a {\n                      \n                      &:hover {\n                          background-color: $ideate-color;\n                          color: #fff;\n                      }\n                  }\n              }\n\n              &.develop {\n                  \n                  a {\n                      \n                      &:hover {\n                          background-color: $ideate-color;\n                          color: #fff;\n                      }\n                  }\n              }\n\n              &.implement {\n\n                  a {\n                      border-radius: 0 6px 6px 0;\n                      border-right: 1px solid #cfdbe2;\n\n                      &:hover {\n                          background-color: $implement-color;\n                          color: #fff;\n                      }\n                  }\n              }\n\n              a {\n                  border-top: 1px solid $cn-border-color;\n                  border-bottom: 1px solid $cn-border-color;\n                  transition: 0.3s;\n                  display: inline-block;\n                  color: #b9b9ba;\n                  width: 100%;\n                  text-align: center;\n\n                  @media #{$mobile} {\n                      padding: 11px 5px !important;\n                      font-size: 11px !important;\n                  }\n              }\n          }\n      }\n  }\n}\n\n.pdf-modal {\n  display: none;\n}\n\n// AI Assistant button in card headings\n::ng-deep .card__bwnh3ai {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  padding: 6px 8px;\n  cursor: pointer;\n  color: $color-neutral-dark;\n  font-size: 14px;\n  border-radius: 4px;\n  transition: color 0.3s ease, background-color 0.3s ease;\n\n  &:hover {\n    color: $develop-color;\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  i {\n    font-size: 14px;\n  }\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
